// extracted by mini-css-extract-plugin
module.exports = {"heading":"informatii-module--heading--1dvxg"};